/*
  © 2025 Jhango
  https://www.jhango.com
*/

class Wishlist extends HTMLElement {
  constructor() {
    super();

    this.setCountBadges();
    this.setContent();
  }

  get wishlist() {
    return JSON.parse(localStorage.getItem("ks-wishlist")) || [];
  }

  set wishlist(array) {
    localStorage.setItem("ks-wishlist", JSON.stringify(array));
  }

  async setProduct(url) {
    let wishlist = this.wishlist;
    const isWishlisted = this.wishlist.some((elem) => elem.url === url);

    if (isWishlisted) {
      wishlist = this.wishlist.filter((elem) => elem.url !== url);
    } else {
      const response = await fetch(`${url}.js`);
      const product = await response.json();
      console.log(product);

      wishlist.push({
        url,
        id: product.id,
        handle: product.handle,
        title: product.title,
        img_src: product.featured_image,
        img_alt: product.featured_image.alt,
        compare_at_price: product.compare_at_price,
        price: product.price,
        price_varies: product.price_varies,
        added_at: Date.now(),
      });
    }

    this.wishlist = wishlist;
    this.setCountBadges();
    this.setContent();
  }

  setCountBadges() {
    document.querySelectorAll(".wishlist-count-badge").forEach((elem) => {
      elem.dataset.count = this.wishlist.length;
      elem.textContent = this.wishlist.length;
    });
  }

  setContent() {
    if (this.wishlist.length) {
      this.querySelector(".wishlist-empty").setAttribute("hidden", "hidden");

      let productList = "";
      let imgWidth, imgHeight;

      switch (this.dataset.imgOrientation) {
        case "ratio-4x3":
          imgWidth = 600;
          imgHeight = Math.round((600 / 4) * 3);
          break;
        case "ratio-16x9":
          imgWidth = 600;
          imgHeight = Math.round((600 / 16) * 9);
          break;
        case "ratio-3x4":
          imgWidth = Math.round((600 / 4) * 3);
          imgHeight = 600;
          break;
        case "ratio-9x16":
          imgWidth = Math.round((600 / 16) * 9);
          imgHeight = 600;
          break;
        default:
          imgWidth = 600;
          imgHeight = 600;
      }

      this.wishlist.forEach((product) => {
        productList += `
          <li class="wishlist-product-item py-3">
            <div class="row mx-n3 align-items-center">
              <div class="col-6 px-3">
                <a href="${product.url}" tabindex="-1">
                  <img 
                    src="${window.Shopify.resizeImage(
                      product.img_src,
                      `${imgWidth}x${imgHeight}`,
                      "center"
                    )}"
                    class="img-fluid ${this.dataset.imgBorder}" 
                    alt="${product.img_alt}" 
                    width="${imgWidth}" 
                    height="${imgHeight}" 
                    loading="lazy">
                </a>
              </div>
              <div class="col-12 px-3 position-relative">
                <div class="me-10">
                  <h4 class="wishlist-product-item-title h6 mb-1 text-truncate">
                    <a href="${
                      product.url
                    }" class="link-dark text-decoration-none">
                      ${product.title}
                    </a>
                  </h4>
                  <p class="wishlist-product-item-price product-price mb-0">
                    <span ${
                      product.compare_at_price > product.price ? "" : "hidden"
                    }>
                      <s class="product-card-price-compare">
                        <span class="visually-hidden">
                          ${window.theme.locales.product.regular_price}
                        </span>
                        ${window.Shopify.formatMoney(product.compare_at_price)}
                      </s>
                      <span class="product-card-price-final product-price-final-sale">
                        <span class="visually-hidden">
                          ${window.theme.locales.product.sale_price}
                        </span>
                        ${window.Shopify.formatMoney(product.price)}
                      </span>
                    </span>
                    <span class="product-card-price-final" ${
                      product.compare_at_price > product.price ? "hidden" : ""
                    }>
                      ${window.Shopify.formatMoney(product.price)}
                    </span>
                  </p>
                  <p class="wishlist-product-item-added-at d-flex align-items-center fs-xs opacity-75 mb-0">
                    <svg xmlns="http://www.w3.org/2000/svg" class="me-2" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline>
                    </svg>
                    ${window.theme.calcTimeAgo(product.added_at)}
                  </p>
                  <product-quick-view-button ${
                    this.dataset.showQuickView === "true" ? "" : "hidden"
                  }>
                    <button 
                      class="btn btn-quick-view btn-sm w-100 mt-3 ${
                        this.dataset.quickViewBtnColor
                      }" 
                      data-product-url="${product.url}" 
                      type="button">
                      ${window.theme.locales.product.quick_view}  
                    </button>
                  </product-quick-view-button>
                </div>
                <button 
                  class="btn wishlist-product-item-btn-remove btn-icon position-absolute top-0 end-0 mt-n4 me-n1"
                  type="button"
                  aria-label="${window.theme.locales.accessibility.remove}"
                  data-product-url="${product.url}">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" class="svg-icon-remove " viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line>
                  </svg>
                </button>
              </div>
            </div>
          </li>
        `;
      });

      this.querySelector(".wishlist-product-list").innerHTML = productList;
      this.querySelector(".wishlist-product-list").removeAttribute("hidden");

      document
        .querySelectorAll(".wishlist-product-item-btn-remove")
        .forEach((removeBtn) => {
          removeBtn.addEventListener("click", () => {
            this.setProduct(removeBtn.dataset.productUrl);

            document
              .querySelectorAll("wishlist-button")
              .forEach((wishlistButton) => {
                wishlistButton.adjustBtn();
              });
          });
        });
    } else {
      this.querySelector(".wishlist-empty").removeAttribute("hidden");
      this.querySelector(".wishlist-product-list").innerHTML = "";
      this.querySelector(".wishlist-product-list").setAttribute(
        "hidden",
        "hidden"
      );
    }
  }
}

customElements.define("wishlist-container", Wishlist);

class WishlistButton extends HTMLElement {
  constructor() {
    super();

    this.btn = this.querySelector("button");
    this.wishlistContainer = document.querySelector("wishlist-container");

    this.adjustBtn();

    this.btn.addEventListener("click", async (event) => {
      event.preventDefault();

      await this.wishlistContainer.setProduct(this.dataset.productUrl);
      this.adjustBtn();
    });
  }

  adjustBtn() {
    const isWishlisted = this.wishlistContainer.wishlist.some(
      (elem) => elem.url === this.dataset.productUrl
    );

    if (isWishlisted) {
      this.btn.classList.add("active");
      this.btn.setAttribute("aria-label", window.theme.locales.wishlist.remove);
      this.btn.setAttribute("aria-pressed", "true");
    } else {
      this.btn.classList.remove("active");
      this.btn.setAttribute("aria-label", window.theme.locales.wishlist.add);
      this.btn.setAttribute("aria-pressed", "false");
    }
  }
}
customElements.define("wishlist-button", WishlistButton);

document.addEventListener('DOMContentLoaded', function() {
  return true;

});
  function validateLicense(url) {
    return true;
  }